import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES, defaultPOShippingDelayEmailValues } from "../common/constants";

const automationsReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_AUTOMATIONS:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.FETCH_AUTOMATIONS_SUCCESS: {
      const { poEmail, poSMS, poShippingEmail, bisEmail } = action.payload.reduce(
        (acc, automation) => {
          if (!acc.poEmail && automation.type === "PO_EMAIL") {
            acc.poEmail = automation;
          }

          if (!acc.poSMS && automation.type === "PO_SMS") {
            acc.poSMS = automation;
          }

          if (!acc.poShippingEmail && automation.type === "PO_SHIPPING_DELAY") {
            acc.poShippingEmail = automation;
          }

          if (!acc.bisEmail && automation.type === "BIS_EMAIL") {
            acc.bisEmail = automation;
          }

          return acc;
        },
        {
          poEmail: null,
          poSMS: null,
          poShippingEmail: null,
          bisEmail: null,
        }
      );

      return {
        ...state,
        po: {
          email: poEmail,
          sms: poSMS,
          shippingEmail: poShippingEmail || defaultPOShippingDelayEmailValues,
        },
        bis: {
          email: bisEmail,
          // sms
        },
        status: DATABASE_STATUTES.LOADED,
      };
    }

    case actionTypes.FETCH_AUTOMATIONS_FAILURE:
    case actionTypes.EDIT_AUTOMATIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    default:
      return state;
  }
};

export default automationsReducer;
